import user_app_notification from "./header_block/user_app_notification";
import user_app_profile from "./header_block/user_app_profile";
import user_app_shortcuts from "./header_block/user_app_shortcuts";
import user_app_settings from "./header_block/user_app_settings";

import store from "../../../store";

window.USR_APP =  new Vue({
	store,
	name : "USER_APP",
	el: '#user_options',

	data () {
		return {
			showModal: false,
		}
	},
	created () {

	},

	components : {
		user_app_notification,
		user_app_profile,
		user_app_shortcuts,
		user_app_settings
	}
});
